import { render } from "./StatNestedPieChart.vue?vue&type=template&id=47cee486&scoped=true"
import script from "./StatNestedPieChart.vue?vue&type=script&lang=js"
export * from "./StatNestedPieChart.vue?vue&type=script&lang=js"

import "./StatNestedPieChart.vue?vue&type=style&index=0&id=47cee486&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47cee486"]])

export default __exports__